<script setup lang="ts">
defineProps<{
  as: "h1" | "h2" | "h3";
}>();
</script>

<template>
  <component
    :is="as"
    class="uppercase text-2xl md:text-4xl"
  >
    <slot />
  </component>
</template>
